import React from 'react';
import { Box, Typography } from '@mui/material';
import WhatsAppFormattedText from '../../WhatsAppFormattedText';

const MediaMessage = ({ message, children }) => {
  return (
    <Box>
      {children}

      {message.media?.caption && (
        <Typography variant="body2" component="div" sx={{ mt: 1, wordBreak: 'break-word' }}>
          <WhatsAppFormattedText text={message.media.caption} />
        </Typography>
      )}
    </Box>
  );
};

export default MediaMessage;
